import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmailDashboardOverdueRoutingModule } from './email-dashboard-overdue-routing.module';
import { EmailDashboardOverdueComponent } from './email-dashboard-overdue/email-dashboard-overdue.component';
import {FormsModule} from '@angular/forms';
import {DropdownModule} from 'primeng/dropdown';
import {CoreModule} from '../../core/core.module';
import {NgbDropdownModule, NgbProgressbarModule} from '@ng-bootstrap/ng-bootstrap';
import {TableModule} from 'primeng/table';

@NgModule({
  imports: [
    CommonModule,
    EmailDashboardOverdueRoutingModule,
    FormsModule,
    DropdownModule,
    CoreModule,
    NgbDropdownModule,
    TableModule,
    NgbProgressbarModule
  ],
  declarations: [EmailDashboardOverdueComponent]
})
export class EmailDashboardOverdueModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard-overdue/email-dashboard-overdue.module.ts